module.exports = __webpack_public_path__ + "static/media/require.c63a9f0d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/require.png
 ** module id = 231
 ** module chunks = 0
 **/